export const LocalStorage = {
    getJwtToken() { return localStorage.getItem('jwt') },
    setJwtToken(token: string) { localStorage.setItem('jwt', token) },
    clearJwtToken() { localStorage.removeItem('jwt') },

    getUser() { return localStorage.getItem('user') },
    setUser(user: string) { localStorage.setItem('user', user) },
    clearUser() { localStorage.removeItem('user') },

    getRole() { return localStorage.getItem('role') },
    setRole(role: string) { localStorage.setItem('role', role) },
    clearRole() { localStorage.removeItem('role') },

    getRefreshToken() { return localStorage.getItem('refreshToken') },
    setRefreshToken(token: string) { localStorage.setItem('refreshToken', token) },
    clearRefreshToken() { localStorage.removeItem('refreshToken') },

    getWarningState() { return localStorage.getItem('warningState') },
    setWarningState(warningState: string) { localStorage.setItem('warningState', warningState) },

    clearAll() { 
        localStorage.removeItem('jwt');
        localStorage.removeItem('user');
        localStorage.removeItem('role');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('warningState');
    }
}